// @flow
import React, { useMemo } from 'react';
import type { Element } from 'react';

import { map } from 'lodash';

import { Link } from '@i18n';
import Dropdown from '../Dropdown';

import StyledLink from '../StyledLink';

const NavigationDropdown = ({
  links,
  children,
  label,
  heroSection
}: {
  links: Array<any>,
  // eslint-disable-next-line react/require-default-props
  children?: Array<Element<any>>,
  label: string,
  heroSection?: boolean
}): Element<any> => {
  const routes: Array<string> = useMemo((): Array<string> => map(links, 'route'), [links]);

  const linkElements: Array<Element<any>> = useMemo((): Array<Element<any>> =>
    links.map(
      ({ id, route, linkLabel }) => (
        <Link href={route} key={id} passHref>
          <StyledLink dropDown={heroSection}>{linkLabel}</StyledLink>
        </Link>
      ),
      [links]
    ));

  return (
    <Dropdown routes={routes} label={label} heroSection={heroSection}>
      {linkElements}
      {children}
    </Dropdown>
  );
};

export default NavigationDropdown;
